import StatefulModal from './StatefulModal';

export default StatefulModal;
